<template>
    <div class="PesquisaVideo">
        <Header></Header>

        <div class="bg-grey-4 py-4">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <DivisorIcone :textSize="24" :title="'Vídeos'"></DivisorIcone>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12 mb-3">
                        <div class="d-flex w-100 border-categorias">
                            <div class="titulo-categorias pt-2 me-2">
                                <span class="txt-h-6 txt-size-12 txt-blue-2 ">
                                    Categorias:
                                </span>
                            </div>
                            <router-link :to="{name:'PesquisaVideo', query:{idCategoria:item.idCategoria, termo: termo, flagTag: flagTag}}" :class="'item-categoria me-2 mb-2 position-relative c-pointer '+(item.classe == 'bold'?'bg-grey-2 txt-white':'')" v-for="(item,index) in lstCategorias" :key="index">
                                {{item.nome}}
                                <span class="position-absolute badge-categoria bg-cores-1 txt-white">
                                    {{(item.quantidade > 99 ?'99+':item.quantidade)}}
                                </span>
                            </router-link>
                        </div>

                    </div>

                    <div class="col-12 col-lg-6">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Pesquisar vídeos por nome" aria-label="Recipient's username" aria-describedby="basic-addon2" v-model="termoBusca" v-on:keyup.enter="buscarTermo">
                            <div class="input-group-append">
                                <span class="input-group-text c-pointer" id="basic-addon2" @click="buscarTermo"><i class="fas fa-search"></i></span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6"></div>     
                </div>
                
            </div>

            <div class="container">
                <div class="row mt-3" v-if="lstVideos.length > 0">
                    <div class="col-4 mb-4" v-for="item in lstVideos" :key="item.idVideo">
                        <CardVideo :video="item"></CardVideo>
                    </div>

                    <div class="col-4 mb-4">
                        <Banner :tipo="'Lateral'" :duplo="false"></Banner>
                    </div>

                    <div class="col-12 mt-3 text-center" v-if="!totalRecords">
                        <button class="btn btn-blue px-5" type="button" @click="carregaPesquisa">
                            Carregar mais
                        </button>
                    </div>
                </div>
                <div class="row mt-4" v-else>
                    <div class="col-12 text-center">
                        <span class="txt-h-3 txt-blue-2">
                            Nenhum resultado encontrado.
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="py-5" v-if="lstBloco1.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!--<DivisorIcone :textSize="24" :title="'Entrevistas'"></DivisorIcone>-->
                        <span class="txt-h-3 txt-blue-2">Entrevistas</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4 mb-4" v-for="item in lstBloco1" :key="item.idVideo">
                        <CardVideo :video="item"></CardVideo>

                    </div>

                </div>
                <Banner :tipo="'Horizontal'" ></Banner>
            </div>
        </div>

        <div class="bg-grey-4 py-5" v-if="lstBloco2.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <!--<DivisorIcone :textSize="24" :title="'Entrevistas'"></DivisorIcone>-->
                        <span class="txt-h-3 txt-w-6 txt-blue-2">Tema:</span> <span class="txt-h-3 txt-blue-2">Legislação</span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-4 mb-4" v-for="item in lstBloco2" :key="item.idVideo">
                        <CardVideo :video="item"></CardVideo>

                    </div>

                </div>
                
            </div>
        </div>
        

        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import DivisorIcone from '@/components/DivisorIcone'
    import CardVideo from '@/components/CardVideo'
    import Banner from '@/components/Banner'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    export default {
        name: 'PesquisaVideo',
        components: { Header, Footer, DivisorIcone, CardVideo, Banner},
        data: function () {
            return {
                lstCategorias: [],

                lstVideos: [],

                lstBloco1: [],
                lstBloco2: [],

                termoBusca: null,
                termo: null,
                idCategoria: 0,
                flagTag: false,

                totalRecords: false,
                qtdRecords: 0,
                take: 5,
                skip: 0
            }
        },
        methods: {
            load() {
                this.totalRecords = false;
                this.qtdRecords = 0;
                this.take = 5;
                this.skip = 0;

               

                this.carregaPesquisa();
                this.carregaBloco1();
                this.carregaBloco2();
            },

            carregaPesquisa() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaVideo`, { params: { take: $this.take, index: $this.skip, termo: $this.termo, idCategoria: $this.idCategoria, flagTag: $this.flagTag } })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.qtdRecords = res.data.data.qtdRecords;
                                if (res.data.data.qtdRecords <= ($this.take * ($this.skip == 0 ? 1 : $this.skip))) {
                                    $this.totalRecords = true;
                                }

                                var result = res.data.data.rows[0];
                                
                                if ($this.skip == 0) {
                                    $this.lstVideos = [];
                                    $this.lstCategorias = [];

                                    for (let i = 0; i < result.lstFiltros.length; i++) {
                                        var categoria = result.lstFiltros[i];
                                        $this.lstCategorias.push(categoria)
                                    }
                                }

                                $this.skip = $this.skip + 1;

                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    $this.lstVideos.push({
                                        idVideo: result.lstResultados[i].href,
                                        urlImagem: result.lstResultados[i].urlImagem,
                                        dtInclusao: result.lstResultados[i].dtPublicacao,
                                        dsCategoria: result.lstResultados[i].subCategoria,
                                        nmTitulo: result.lstResultados[i].titulo,
                                        dsVideo: result.lstResultados[i].subTitulo,
                                    })
                                }
                            }
                            
                            
                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaBloco1() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaVideo`, { params: { take: 6, index: 0, termo: null, idCategoria: 3, flagTag: null } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data.rows[0];
                            $this.lstBloco1 = [];
                            if (result) {
                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    if (i < 4) {
                                        $this.lstBloco1.push({
                                            idVideo: result.lstResultados[i].href,
                                            urlImagem: result.lstResultados[i].urlImagem,
                                            dtInclusao: result.lstResultados[i].dtPublicacao,
                                            dsCategoria: result.lstResultados[i].subCategoria,
                                            nmTitulo: result.lstResultados[i].titulo,
                                            dsVideo: result.lstResultados[i].subTitulo,
                                        })
                                    }
                                }
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },

            carregaBloco2() {
                let $this = this;
                axios.get(`${urlApi}/PesquisaPortal/PesquisaVideo`, { params: { take: 6, index: 0, termo: null, idCategoria: 15, flagTag: null } })
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data.rows[0];
                            $this.lstBloco2 = [];

                            if (result) {
                                for (let i = 0; i < result.lstResultados.length; i++) {
                                    if (i < 4) {
                                        $this.lstBloco2.push({
                                            idVideo: result.lstResultados[i].href,
                                            urlImagem: result.lstResultados[i].urlImagem,
                                            dtInclusao: result.lstResultados[i].dtPublicacao,
                                            dsCategoria: result.lstResultados[i].subCategoria,
                                            nmTitulo: result.lstResultados[i].titulo,
                                            dsVideo: result.lstResultados[i].subTitulo,
                                        })
                                    }
                                }
                            }
                            
                        } else {
                            avisoErro("Não foi possível carregar a pesquisa");
                            $this.noticiaDestaque = null;
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar a pesquisa");
                        $this.noticiaDestaque = null;
                    });
            },


            buscarTermo() {
                if (this.termoBusca != null && this.termoBusca != '') {
                    this.$router.push({ path: 'PesquisaVideo', query: { termo: this.termoBusca } });
                } else {
                    this.$router.push({ path: 'PesquisaVideo' });
                }
            },


        },
        mounted: function () {
            if (this.$route.query.termo != undefined) {
                this.termo = this.$route.query.termo;

                if (this.$route.query.flagTag == undefined || !this.$route.query.flagTag) {
                    this.termoBusca = this.termo;
                }
                
            }

            if (this.$route.query.idCategoria != undefined) {
                this.idCategoria = this.$route.query.idCategoria;
            }

            if (this.$route.query.flagTag != undefined) {
                this.flagTag = this.$route.query.flagTag;
            }
            this.load();
        },
        watch: {
            $route(to) {
                if (to.query.termo != undefined) {
                    this.termo = to.query.termo;

                    if (to.query.flagTag == undefined || !to.query.flagTag) {
                        this.termoBusca = this.termo;
                    }
                } else {
                    this.termo = null;
                    this.termoBusca = null;
                }


                if (to.query.idCategoria != undefined) {
                    this.idCategoria = to.query.idCategoria;
                } else {
                    this.idCategoria = 0;
                }

                if (to.query.flagTag != undefined) {
                    this.flagTag = to.query.flagTag;
                } else {
                    this.flagTag = false;
                }

                this.load();
            }
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

    .item-categoria {
        background: #FFFFFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        color: #959595;
        padding: 9px 5px;
    }

    .badge-categoria {
        left: -10px;
        top: -15px;
        font-size: 10px;
        padding: 5px 10px;
        border-radius: 50%;
    }

</style>

